import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "lucide-react";
import { Icon } from "../icons.js";
export function TopicRow({ name, date, open, onToggle, controls, children }) {
    return (_jsxs("li", { "data-topic": "", style: { borderBottom: "1px solid var(--line)" }, children: [_jsxs("button", { type: "button", "data-topic-row": "", "aria-expanded": open, "aria-controls": open ? controls : undefined, onClick: () => onToggle(), style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "var(--space-15)",
                    width: "100%",
                    // knowledge-page design-spec §4.3: 56px minimum, padding `12px 10px 12px 6px`.
                    minHeight: "var(--space-7)",
                    padding: "var(--space-15) 10px var(--space-15) var(--space-075)",
                    margin: 0,
                    border: "none",
                    borderRadius: open ? 0 : "var(--radius-control)",
                    background: "var(--topic-row-bg, var(--sheet))",
                    color: "var(--ink-1)",
                    fontFamily: "var(--font-sans)",
                    textAlign: "left",
                    cursor: "pointer",
                    position: open ? "sticky" : undefined,
                    top: open ? 0 : undefined,
                    zIndex: open ? 2 : undefined,
                    boxShadow: open ? "0 1px 0 var(--line)" : undefined,
                    transitionProperty: "background-color",
                    transitionDuration: "var(--dur-fast)",
                    transitionTimingFunction: "var(--ease-out)",
                }, children: [_jsx("span", { "aria-hidden": "true", "data-topic-chevron": "", style: {
                            display: "inline-flex",
                            flex: "none",
                            color: open ? "var(--ink-1)" : "var(--ink-3)",
                            transform: open ? "rotate(90deg)" : undefined,
                            transitionProperty: "transform",
                            transitionDuration: "var(--dur-fast)",
                            transitionTimingFunction: "var(--ease-out)",
                        }, children: _jsx(Icon, { icon: ChevronRight, size: 16, strokeWidth: 1.6, "aria-hidden": "true" }) }), _jsx("span", { "data-topic-name": "", style: {
                            flex: 1,
                            fontSize: "var(--type-row-title-size)",
                            lineHeight: "var(--type-row-title-line)",
                            fontWeight: open ? "var(--type-body-weight-current)" : "var(--type-body-weight)",
                        }, children: name }), _jsx("span", { "data-topic-date": "", style: { fontSize: "var(--type-small-size)", color: "var(--ink-2)", whiteSpace: "nowrap", textAlign: "right" }, children: date })] }), open && (_jsx("div", { id: controls, "data-topic-group": "", style: {
                    // knowledge-page design-spec §3.3 / §4.3: `margin: 0 0 24px 13px; padding: 14px 0 0 21px`.
                    margin: "0 0 var(--space-3) 13px",
                    padding: "14px 0 0 21px",
                    borderLeft: "2px solid var(--tone-2)",
                }, children: children }))] }));
}
